import client from '@stores/apollo'
import { IAdminSearchEmployee, IConnection } from '@api/types'
import { adminEmployeeSearch } from './queries'

interface Payload {
  data: {
    viewer: {
      company: {
        search: {
          employees: IConnection<IAdminSearchEmployee>
        }
      }
    }
  }
}

export default async function adminEmployee({
  query,
  apId,
  after,
  location,
  unseated,
}: {
  query: string
  apId: string
  after?: string | null
  location?: boolean
  unseated?: boolean
}): Promise<IConnection<IAdminSearchEmployee>> {
  const variables = {
    query,
    unseated,
    assignmentPlanId: apId,
    location,
    fetchEmployeeBooking: false,
    after: after || undefined,
  }

  return await client.gql.query({ query: adminEmployeeSearch, variables }).then(
    ({
      data: {
        viewer: {
          company: {
            search: { employees },
          },
        },
      },
    }: Payload) => employees
  )
}
